import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components/bootstrap';

const StyledButton = styled(Button)`
  border-radius: 4px;
  width: 110px;
`;

type Props = {
  title: string;
  onClick?: () => void;
  to?: string;
  disabled?: boolean;
  hint?: string;
};

const StepActionButton = ({
  title,
  onClick = undefined,
  to = undefined,
  disabled = false,
  hint = undefined,
}: Props) => {
  if (onClick) {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onClick();
    };

    return (
      <StyledButton
        title={hint}
        bsStyle="gray"
        bsSize="xs"
        aria-label={title}
        onClick={handleClick}
        disabled={disabled}>
        {title}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      role="link"
      bsStyle="gray"
      bsSize="xs"
      aria-label={title}
      href={to}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
      target="_blank"
      rel="noopener noreferrer"
      title={hint}
      disabled={disabled}>
      {title}
    </StyledButton>
  );
};

export default StepActionButton;
